import { render, staticRenderFns } from "./appAvatarSelect.vue?vue&type=template&id=b19c00ee"
import script from "./appAvatarSelect.vue?vue&type=script&lang=js"
export * from "./appAvatarSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports